<template>
  <div style="padding: 0 12px;">
    <div class="tab-selector">
      <div :class="{active:!folderId}" @click="search()">
        <span><a-icon type="appstore"/> 全部</span>
        <span>{{ albumStats["photo_release"] }}</span>
      </div>
      <template v-for="(folder, index) in result.data">
        <div :class="{active:folderId===folder.id}" :key="folder.id"
             @click="search(folder.id)" @mouseenter="hover_id=folder.id" @mouseleave="hover_id=''">
          <span><a-icon type="folder"/> {{ folder.info.name }}</span>
          <span v-if="hover_id===folder.id">
            <a-icon @click.stop="moveup(index)" type="arrow-up" v-if="index"/>
            <a-icon @click.stop="update(folder)" type="form"/>
            <a-icon @click.stop="remove(folder)" type="delete"/>
          </span>
          <span v-else-if="folderStats[folder.id]">{{ folderStats[folder.id]["photo_total"] }}</span>
          <span v-else>0</span>
        </div>
      </template>
      <FolderForm :album="album" @saved="refresh" ref="folderForm"/>
    </div>
  </div>
</template>

<script>
import api from "../../../../../utils/api";
import func from "../../../../../utils/func";
import cache from "../../../../../utils/cache";
import FolderForm from "./FolderForm";

export default {
  name: "FolderPane",
  components: {FolderForm},
  props: {
    album: Object,
    albumStats: Object,
  },
  data() {
    return {
      result: {
        total: 0,
        data: []
      },
      timeId: null,
      hover_id: "",
      folderStats: {},
      folderIds: [],
    }
  },
  computed: {
    folderId() {
      return this.$attrs.value;
    }
  },
  created() {
    this.refresh().then(this.restats);
  },
  destroyed() {
    clearTimeout(this.timeId);
  },
  methods: {
    create() {
      this.$refs.folderForm.create(this.result.total);
    },
    update(folder) {
      this.$refs.folderForm.update(folder);
    },
    moveup(index) {
      if (index <= 0) return;
      let item1 = this.result.data[index];
      let item2 = this.result.data[index - 1];
      item1.info.sort_idx -= 1;
      item2.info.sort_idx += 1;
      cache.v1.album.folder.update(this.album.id, item1.id, item1.info);
      cache.v1.album.folder.update(this.album.id, item2.id, item2.info);
      func.arraySwap(this.result.data, index, index - 1);
    },
    remove(folder) {
      const self = this;
      this.$confirm({
        title: `确认删除“${folder.info.name}”吗？`,
        content: "删除子相册将自动解除图片关联，但不会删除图片。此操作无法恢复，您确认要删除吗？",
        onOk() {
          cache.v1.album.folder.delete(self.album.id, folder.id).then(self.refresh);
        }
      });
    },
    restats() {
      this.timeId && clearTimeout(this.timeId);
      api.v1.album.stats
          .folder(this.album.id, this.folderIds)
          .then(res => this.folderStats = res);
      this.timeId = func.setTimeout(30000, this.restats);
    },
    search(id) {
      this.$emit("input", func.stringStrict(id));
      this.$emit("search"); // search after input
    },
    refresh() {
      const self = this;
      return cache.v1.album.folder.search(this.album.id)
          .then(res => {
            self.$set(self.result, "data", res.data);
            self.$set(self.result, "total", res.total);
            self.folderIds = func.getByKey(res.data, "id");
          })
    }
  }
}
</script>

<style lang="less" scoped>
.tab-selector {
  font-size: 12px;
  margin: 10px -15px;
  overflow-x: hidden;
  overflow-y: auto;

  div {
    cursor: pointer;
    padding: 5px 15px;

    span:last-child {
      display: block;

      .anticon {
        color: #999;
        margin-right: 6px;
      }
    }
  }

  .active {
    color: #1890ff;
  }
}
</style>
